<!-- Custom Language Selector — no Bootstrap dependency -->
<div class="lang-selector" [class.open]="isOpen">

  <!-- Toggle button -->
  <button class="lang-trigger"
          type="button"
          (click)="isOpen = !isOpen"
          [attr.aria-expanded]="isOpen"
          aria-haspopup="listbox"
          [attr.aria-label]="'اللغة الحالية: ' + language?.name">
    <img [src]="language?.flag" [alt]="language?.name" class="lang-flag">
    <span class="lang-name">{{ language?.name }}</span>
    <svg class="lang-chevron" [class.rotated]="isOpen"
         width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Dropdown menu -->
  <div class="lang-menu" role="listbox" [attr.aria-label]="'اختر اللغة'">
    <button *ngFor="let lang of languages; trackBy: trackByLang"
            class="lang-option"
            [class.active]="lang.active"
            type="button"
            role="option"
            [attr.aria-selected]="lang.active"
            (click)="select(lang.lang)">
      <img [src]="lang.flag" [alt]="lang.name" class="lang-flag">
      <span>{{ lang.name }}</span>
      <svg *ngIf="lang.active" class="lang-check"
           width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

</div>
